/** @format */

import { makeStyles, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import Pager from '../../../../components/Adescom/Pager';
import AddButton from '../../../../components/Buttons/AddButton';
import RemoveButton from '../../../../components/Buttons/RemoveButton';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import TableHeaderContentCell from '../../../../components/Table/TableHeaderContentCell';
import { configDefault } from '../../../../core/config';
import { ItemLoaders } from '../../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import { roles, UserRoleHelper } from '../../../../helpers/UserRoleHelper';
import { FractionCollectionInterface } from '../../../../interfaces/api/FractionCollectionInterface';
import FractionInterface from '../../../../interfaces/billing/FractionInterface';
import PricelistSchemaElementInterface from '../../../../interfaces/billing/PricelistSchemaElementInterface';
import Filter from '../../../../interfaces/forms/Filter';
import Order from '../../../../interfaces/forms/Order';
import { fractionsConstants } from '../../../../modules/fractions/actions';
import { fractionsReducerType } from '../../../../modules/fractions/reducers';
import oplAppStyle from '../../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';
import FakePagination from '../../../../components/Pagination/FakePagination';

interface PricelistSchemaElementFractionProps {
    classes: any;
    setFractions: (fractions: Array<FractionInterface>) => void;
    selectedFractions: Array<FractionInterface>;
    entity: PricelistSchemaElementInterface;
}

const PricelistSchemaElementFraction = (props: PricelistSchemaElementFractionProps): React.ReactElement => {
    const dispatch = useDispatch();
    const FRACTION_ES_URI = '/fractions';

    const [orders, setOrders] = useState<Array<Order>>([]);
    const [filters, setFilters] = useState<Array<Filter>>([]);

    const { setFractions, selectedFractions, classes } = props;

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };

    const { collections } = useSelector((state: { fractionsReducers: fractionsReducerType }) => {
        return state.fractionsReducers;
    });

    const addFraction = (param: { el: FractionInterface }): void => {
        if (
            !selectedFractions.some((sf: FractionInterface) => {
                return sf.id === param.el.id;
            })
        ) {
            let newArr = [...selectedFractions, param.el];
            setFractions(newArr);
        }
    };
    const removeFraction = (param: { el: FractionInterface }): void => {
        let newArr = [...selectedFractions];
        selectedFractions.forEach((el: FractionInterface, indx: number) => {
            if (el.id === param.el.id) {
                newArr.splice(indx, 1);
            }
        });
        setFractions(newArr);
    };

    useEffect(() => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(FRACTION_ES_URI, configDefault.PLATFORM_API_PREFIX)),
            fractionsConstants.LIST,
            [{ name: 'prefixTypeId', value: props.entity.type }, ...filters],
            orders,
            (data: FractionCollectionInterface) => {},
            {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            }
        );
    }, [dispatch, props.entity.type, orders, filters]);

    const paginationCallbackFunction = (uri: string | null): void => {
        if (!uri) {
            uri = FormGeneralHelper.getPath(FRACTION_ES_URI, configDefault.PLATFORM_API_PREFIX);
        }

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(FormGeneralHelper.getByUri(uri), fractionsConstants.LIST, [], [], (data: FractionCollectionInterface) => {}, {
            propagateDataToCallback: false,
            dispatchAfterCallback: true,
        });
    };

    const updateOrderList = (orders: Array<Order>): void => {
        setOrders(orders);
    };
    const updateFilterList = (filters: Array<Filter>): void => {
        setFilters(filters);
    };

    return (
        <GridContainer>
            <GridItem xs={6}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell textAlign="left" title="clients:c.commands" />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="pricelists:h.name"
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    fieldName="mainname"
                                    showSort={true}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {collections &&
                            collections['hydra:member'].map((el: FractionInterface) => {
                                return (
                                    <TableRow key={el.id}>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                                <AddButton
                                                    tooltipTitle="pricelists:button.assign_fraction"
                                                    callback={addFraction}
                                                    callbackParam={{ el: el }}
                                                    disabled={selectedFractions.some((sf: FractionInterface) => {
                                                        return sf.id === el.id;
                                                    })}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            {el.mainname}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell classes={tableCellRoot} colSpan={4}>
                                {collections && collections['hydra:view'] && (
                                    <Pager callback={paginationCallbackFunction} views={collections['hydra:view']} />
                                )}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </GridItem>
            <GridItem xs={6}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell textAlign="left" title="clients:c.commands" />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} align="left">
                                <TableHeaderContentCell textAlign="left" title="pricelists:h.name" />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <FakePagination>
                            {selectedFractions &&
                                selectedFractions.map((el: FractionInterface) => {
                                    return (
                                        <TableRow key={el.id}>
                                            <TableCell classes={tableStickyHeader} align="left">
                                                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                                    <RemoveButton
                                                        tooltipTitle="pricelists:button.remove_assigned_fraction"
                                                        callback={removeFraction}
                                                        callbackParam={{ el: el }}
                                                        disabled={
                                                            !selectedFractions.some((sf: FractionInterface) => {
                                                                return sf.id === el.id;
                                                            })
                                                        }
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell classes={tableStickyHeader} align="left">
                                                {el.mainname}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </FakePagination>
                    </TableBody>
                </Table>
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(PricelistSchemaElementFraction);
